// Search over the full Material Symbols catalog for the admin icon picker.
// The catalog (name + semantic tags/aliases) is a ~1MB generated JSON, so it is
// loaded lazily the first time an admin actually searches and then memoized for
// the rest of the session — it never touches the public form bundle.
// Regenerate the data with `node scripts/generate-icon-catalog.mjs`.

let catalogPromise = null;

// Lazily import the generated catalog as its own chunk. Returns rows of
// [name, "space joined tags"].
export const loadIconCatalog = () => {
  if (!catalogPromise) {
    catalogPromise = import('./material-symbols-catalog.json')
      .then((mod) => mod.default)
      .catch((err) => {
        // Allow a later retry if the chunk failed to load.
        catalogPromise = null;
        throw err;
      });
  }
  return catalogPromise;
};

// Rank a glyph for a query: exact name beats name-prefix beats name-substring
// beats a tag/alias match. Lower is better; null means no match.
const rank = (name, tags, query) => {
  if (name === query) return 0;
  if (name.startsWith(query)) return 1;
  if (name.includes(query)) return 2;
  if (tags.includes(query)) return 3;
  return null;
};

// Search the catalog, returning at most `limit` glyph names best-first.
export const searchIcons = (catalog, query, limit = 120) => {
  const q = query.trim().toLowerCase();
  if (!q || !catalog) return [];
  const scored = [];
  for (const [name, tags] of catalog) {
    const score = rank(name, tags, q);
    if (score !== null) scored.push({ name, score });
  }
  scored.sort((a, b) => (a.score - b.score) || a.name.localeCompare(b.name));
  return scored.slice(0, limit).map((row) => row.name);
};
